import type { FacilityReportStatus } from '@/models/types/report/facility-report-state'

enum AlarmActionType {
    Ack,
    Archive,
    NotifyToPlant,
}

type AlarmAction = { alarmId: number; actionType: AlarmActionType }

type ReportAction = { reportId: number; statoReport: FacilityReportStatus }

export { AlarmActionType, type AlarmAction, type ReportAction }
